interface RoutePlaceholderProps {
    title: string;
}

export function RoutePlaceholder({ title }: RoutePlaceholderProps) {
    return (
        <div className="flex h-full items-center justify-center">
            <h1 className="text-muted-foreground text-2xl font-semibold">{title}</h1>
        </div>
    );
}
